import { useMemo } from 'react';

import { useAppSelector } from '~/hooks/useAppSelector';
import { MeasurementUnit } from '~/types/interfaces/measurementUnit';

export const useGetMeasurementUnits = () => {
  const { selectedEcosystem } = useAppSelector(({ ecosystem }) => ecosystem);

  const measurementUnits = useMemo(() => {
    const measurementUnits: MeasurementUnit[] = [];

    if (selectedEcosystem?.measurementUnits?.length) {
      measurementUnits.push(...selectedEcosystem.measurementUnits);
    }

    return measurementUnits?.reduce(
      (group: { [key: string]: MeasurementUnit[] }, measurementUnit) => {
        const { category } = measurementUnit;
        group[category] = group[category] ?? [];
        group[category].push(measurementUnit);
        return group;
      },
      {},
    );
  }, [selectedEcosystem]);

  return { measurementUnits };
};
